import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import EditIcon from '@mui/icons-material/Edit';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormLabel,
    TextField
} from '@mui/material';
import authService from '../../../api-authorization/AuthorizeService';

const EditBlockDialog = ({ location, open, onClose, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const { handleSubmit, register, reset } = useForm({ defaultValues: location });

    // Reset form when location changes
    useEffect(() => {
        reset(location);
    }, [location, reset]);

    const updateSubLocation = async (subLocation) => {
      if (
            !subLocation.farmName ||
            !subLocation.name 
        )
            return toast.error('Please complete all required fields.');

        const token = await authService.getAccessToken();
        try {
            setLoading(true);
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/api/sublocations/update`,
                {
                    method: 'PUT',
                    headers: !token
                        ? {}
                        : {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        },
                    body: JSON.stringify(subLocation)
                }
            );
            if (response.ok) {
                toast.success('Block updated successfully!');
                onSuccess();
            } else {
                toast.error(`${response.status} ${response.statusText}`);
            }
        } catch (err) {
            toast.error('Error: ' + err);
            console.log('err', err);
        }
        setLoading(false);
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <form onSubmit={handleSubmit(updateSubLocation)}>
                <DialogTitle>
                    <EditIcon /> Edit Block
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <FormControl>
                            <FormLabel>Farm Name</FormLabel>
                            <TextField autoFocus required {...register('farmName')} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Block Name</FormLabel>
                            <TextField autoFocus required {...register('name')} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Crop</FormLabel>
                            <TextField {...register('crop')} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Row Width (ft)</FormLabel>
                            <TextField {...register('rowWidthFt')} />
                        </FormControl>                        
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={onClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="outlined" disabled={loading}>
                        Save Changes
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default EditBlockDialog;
